/**
 * InfoPage - Public business info page (Stripe verification)
 * No authentication required. Zero app dependencies.
 * To remove: delete this file + remove import/route from App.tsx + delete public/info-images/
 */

const gallery = [
  { src: '/braydin/update-rushmore.jpg', title: 'On the Road', subtitle: 'Travel Photography' },
  { src: '/braydin/nature-mountains.jpg', title: 'High Country', subtitle: 'Landscape Photography' },
  { src: '/braydin/nature-canyon.jpg', title: 'Canyon Light', subtitle: 'Nature Photography' },
  { src: '/braydin/nature-falls.jpg', title: 'Wild Water', subtitle: 'Landscape Photography' },
]

export function InfoPage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="border-b border-gray-100 sticky top-0 bg-white/90 backdrop-blur-sm z-10">
        <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
          <span className="text-xl font-semibold text-gray-900 tracking-tight">Braydin Wright</span>
          <a
            href="/login"
            className="text-sm font-medium text-[#6b7850] hover:text-[#5c5b44] transition-colors"
          >
            Sign In
          </a>
        </div>
      </header>

      {/* Hero */}
      <section className="relative w-full overflow-hidden bg-black">
        <img
          src="/braydin/login-forest.jpg"
          alt="Landscape and nature photography"
          className="w-full h-[50vh] sm:h-[60vh] md:h-[70vh] object-cover opacity-90"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-8 sm:p-12 md:p-16">
          <div className="max-w-6xl mx-auto">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-3">
              Braydin Wright
            </h1>
            <p className="text-base sm:text-lg text-gray-200 max-w-2xl leading-relaxed">
              Original landscape and nature photography, captured along the journey.
            </p>
          </div>
        </div>
      </section>

      {/* Intro Text */}
      <section className="max-w-6xl mx-auto px-6 py-12 sm:py-16 text-center">
        <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
          Braydin Wright is a photography collection — original landscape, nature, and travel
          work. Step inside for an exclusive look at the photography and the places behind it.
        </p>
      </section>

      {/* Gallery Grid */}
      <section className="max-w-6xl mx-auto px-6 pb-16">
        <h2 className="text-2xl font-semibold text-gray-900 mb-8 text-center">The Collection</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
          {gallery.map(({ src, title, subtitle }) => (
            <div key={title} className="group overflow-hidden rounded-2xl bg-gray-50">
              <div className="overflow-hidden">
                <img
                  src={src}
                  alt={title}
                  className="w-full h-72 sm:h-80 md:h-96 object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5">
                <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
                <p className="text-sm text-gray-500 mt-1">{subtitle}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* About */}
      <section className="bg-gray-50 py-16">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">About Braydin Wright</h2>
          <p className="text-gray-600 leading-relaxed">
            Braydin Wright shares original photography — landscape, nature, and travel work
            captured along the way. Members get access to the full photography collection and
            every new release. Whether you're here for the scenery or the craft, there's a place
            for you.
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-gray-100 py-8">
        <div className="max-w-6xl mx-auto px-6 text-center">
          <p className="text-sm text-gray-900 font-medium mb-1">Braydin Wright</p>
          <p className="text-sm text-gray-500">
            <a href="mailto:braydin@fansupportdesk.com" className="hover:text-[#6b7850] transition-colors">
              braydin@fansupportdesk.com
            </a>
          </p>
          <p className="text-xs text-gray-400 mt-3">
            &copy; {new Date().getFullYear()} Braydin Wright. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  )
}
